(() => {
  const lists = document.querySelectorAll("[data-tm-kayit-list]");
  if (!lists.length) return;

  const shuffle = (items) => {
    for (let i = items.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      const tmp = items[i];
      items[i] = items[j];
      items[j] = tmp;
    }
    return items;
  };

  lists.forEach((list) => {
    const show = Number(list.getAttribute("data-tm-kayit-show") || "12");
    const items = Array.from(list.children);
    if (items.length < 2) return;

    shuffle(items).forEach((el, idx) => {
      list.appendChild(el);
      if (idx < show) {
        el.hidden = false;
        el.removeAttribute("hidden");
      } else {
        el.hidden = true;
        el.setAttribute("hidden", "");
      }
    });
  });
})();
